/**
 * How the home page's news section fills its grid (decided 24/10/2026): the
 * newest articles, one full row at each width, then "Xem thêm" to /news. One
 * column below `sm`, two from `sm`, three from `lg`, so two cards, two, three.
 * The page asks for the most it shows (`LATEST_NEWS_LIMIT`, the same filter
 * seo.ts puts in the HTML; a test holds them equal) and hides the rest with CSS:
 * a lazy cover inside `display: none` is never fetched.
 */
export const LATEST_NEWS_LAYOUT = [
  { breakpoint: 'base', columns: 1, shown: 2 },
  { breakpoint: 'sm', columns: 2, shown: 2 },
  { breakpoint: 'lg', columns: 3, shown: 3 },
] as const;

/** The most cards any width shows: what the page asks the server for. */
export const latestNewsMax = (): number => Math.max(...LATEST_NEWS_LAYOUT.map((l) => l.shown));

/**
 * Classes for the wrapper of the i-th card (and of its placeholder): shown from
 * the first width whose count reaches it, hidden below. Literal strings, since
 * Tailwind only generates classes it finds written out. `grid` makes the card
 * fill its cell's height, like the cards beside it.
 */
export function latestCardClass(i: number): string {
  const [base, sm, lg] = LATEST_NEWS_LAYOUT;
  if (i < base.shown) return 'grid';
  if (i < sm.shown) return 'hidden sm:grid';
  if (i < lg.shown) return 'hidden lg:grid';
  return 'hidden';
}
